var map = {
	"./de.png": "./src/assets/pre/ny-home-promo/de.png",
	"./en.png": "./src/assets/pre/ny-home-promo/en.png",
	"./es.png": "./src/assets/pre/ny-home-promo/es.png",
	"./fr.png": "./src/assets/pre/ny-home-promo/fr.png",
	"./it.png": "./src/assets/pre/ny-home-promo/it.png",
	"./pt.png": "./src/assets/pre/ny-home-promo/pt.png",
	"./ru.png": "./src/assets/pre/ny-home-promo/ru.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/pre/ny-home-promo sync recursive ^\\.\\/.*\\.png$";